import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button, ShimmerLoader, TextLink, Typography } from '@guildeducationinc/recess';
import ProgramCardList from '@shared/ProgramCardList/ProgramCardList';
import ErrorMessage from '@shared/ErrorMessage/ErrorMessage';
import { CATALOG_BOOKMARKS_PATH, CATALOG_URL, MOBILE_QUERY } from '@src/constants';
import { clickable } from '@src/analytics';
import useGetBookmarks, { BookmarksType } from '@src/hooks/useGetBookmarks';
import BookmarksActionCard from './BookmarksActionCard/BookmarksActionCard';
import './Bookmarks.scss';

const Bookmarks: React.FC = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  const { bookmarks, loading, error } = useGetBookmarks();
  if (error) {
    return <ErrorMessage />;
  }

  const seeAllBookmarks = bookmarks.length > 0;
  const maxDisplayLength = 3;

  const programsArray = bookmarks
    .slice(0, maxDisplayLength)
    .map((bookmark: BookmarksType) => bookmark.program);

  return (
    <ShimmerLoader loaded={!loading} label='bookmarks' height='10rem'>
      {seeAllBookmarks && (
        <div className='bookmarksIntroText'>
          <Typography variant='body1'>
            You have {bookmarks.length} bookmark{bookmarks.length > 1 && 's'} total.
          </Typography>
          <TextLink
            href={`${CATALOG_URL}/${CATALOG_BOOKMARKS_PATH}`}
            onClick={() =>
              clickable({
                product: 'home',
                loggedIn: true,
                tag: 'learn_skills',
                text: 'bookmarks_see_all',
                type: 'link',
              })
            }
            variant='standalone'
          >
            See all
          </TextLink>
        </div>
      )}
      <ProgramCardList
        programCardType='bookmarks'
        programs={programsArray}
        renderIfEmpty={<BookmarksActionCard />}
      />
      {seeAllBookmarks && (
        <Button
          fullWidth={isMobile}
          href={`${CATALOG_URL}/${CATALOG_BOOKMARKS_PATH}`}
          onClick={() =>
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: 'bookmarks_see_all_bookmarks',
              type: 'button',
            })
          }
        >
          See all bookmarks
        </Button>
      )}
    </ShimmerLoader>
  );
};

export default Bookmarks;
